"use client";

import { motion } from "framer-motion";
import { Copy, KeyRound } from "lucide-react";

import { useSecurityMockContent } from "@/hooks/security/useSecurityMockContent";

const SCOPES = ["read:projects", "write:schedule", "read:breakdown"];

export const ApiKeysVisual = () => {
  const { apiKeysVisual } = useSecurityMockContent();

  return (
    <div className="flex w-full flex-col">
      <motion.div
        className="overflow-hidden rounded-xl border border-zinc-200/50 bg-zinc-100 font-mono shadow-md dark:border-zinc-700/50 dark:bg-[#0a0c10] dark:shadow-xl"
        initial={{ opacity: 0, y: 6 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <div className="flex items-center justify-between gap-2 border-b border-zinc-200/50 bg-zinc-200/40 px-3 py-2 dark:border-white/[0.06] dark:bg-transparent">
          <div className="flex items-center gap-2">
            <KeyRound className="size-3.5 text-brand" aria-hidden />
            <span className="text-[10px] font-medium text-zinc-700 dark:text-white/80">
              {apiKeysVisual.header}
            </span>
          </div>
          <span className="flex items-center gap-1 text-[9px] text-emerald-600 dark:text-emerald-400">
            <span className="size-1.5 rounded-full bg-emerald-500 dark:bg-emerald-400" />
            {apiKeysVisual.live}
          </span>
        </div>
        <div className="flex flex-col gap-3 p-3">
          <div className="flex flex-col gap-1">
            <span className="text-[9px] uppercase tracking-wider text-zinc-500 dark:text-white/35">
              {apiKeysVisual.keyLabel}
            </span>
            <div className="flex items-center justify-between gap-2 rounded-md border border-zinc-200/50 bg-white px-2.5 py-2 dark:border-white/[0.05] dark:bg-[#14161c]">
              <span className="text-[10px] text-brand dark:text-brand/90">
                rvt_live_4f8a••••••••••••
              </span>
              <Copy
                className="size-3 text-zinc-400 dark:text-white/30"
                aria-hidden
              />
            </div>
          </div>
          <div className="flex flex-col gap-1.5">
            <span className="text-[9px] uppercase tracking-wider text-zinc-500 dark:text-white/35">
              {apiKeysVisual.scopesLabel}
            </span>
            <div className="flex flex-wrap gap-1">
              {SCOPES.map((scope) => (
                <span
                  key={scope}
                  className="rounded border border-zinc-300/80 bg-zinc-200/60 px-1.5 py-0.5 text-[9px] text-zinc-700 dark:border-white/[0.05] dark:bg-white/[0.06] dark:text-white/70"
                >
                  {scope}
                </span>
              ))}
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};
